
import Vue from 'vue'

export default Vue.extend({
  name: 'pd-button',

  data: () => ({}),
  methods: {
    doclick:function (){
      this.click(this.datatopass)
    }
  },
  props: {
    click: Function,
    label: String,
    datatopass:String
  }
})
